import { PrivacyApplicantCandidatePage } from './PrivacyApplicantCandidatePage';

export default PrivacyApplicantCandidatePage;
